"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getValueForPath = void 0;
const getValueForPath = (obj, path) => {
    try {
        return String(path)
            .split('.')
            .reduce((e, i) => e[i], obj);
    }
    catch (e) {
        return undefined;
    }
};
exports.getValueForPath = getValueForPath;
